var path = 'webapps/signup/AppEntry.ng.html';
var html = "<div class=\"container-fluid\">\n  \n \t  <app-signup ng-model=\"vm.company\"></app-signup>\n\n</div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


/*****************
 ** WEBPACK FOOTER
 ** ./signup/AppEntry.ng.html
 ** module id = 5
 ** module chunks = 0
 **/